/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { GeneratedRoute } from '@elegant-router/types';

export const generatedRoutes: GeneratedRoute[] = [
  {
    name: '403',
    path: '/403',
    component: 'layout.blank$view.403',
    meta: {
      title: '403',
      i18nKey: 'route.403',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '404',
    path: '/404',
    component: 'layout.blank$view.404',
    meta: {
      title: '404',
      i18nKey: 'route.404',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: '500',
    path: '/500',
    component: 'layout.blank$view.500',
    meta: {
      title: '500',
      i18nKey: 'route.500',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'ad-serving-data',
    path: '/ad-serving-data',
    component: 'layout.base',
    redirect: '/ad-serving-data/data',
    meta: {
      title: 'ad-serving-data',
      i18nKey: 'route.ad-serving-data',
      icon: 'carbon:bullhorn',
      order: 3
    },
    children: [
      {
        name: 'ad-serving-data_data',
        path: '/ad-serving-data/data',
        component: 'view.ad-serving-data_data',
        meta: {
          title: 'ad-serving-data_data',
          i18nKey: 'route.ad-serving-data_data',
          icon: 'carbon:chart-column',
          keepAlive: true,
          order: 1
        }
      },
      {
        name: 'ad-serving-data_fraud-source',
        path: '/ad-serving-data/fraud-source',
        component: 'view.ad-serving-data_fraud-source',
        meta: {
          title: 'ad-serving-data_fraud-source',
          i18nKey: 'route.ad-serving-data_fraud-source',
          icon: 'carbon:warning-hex',
          order: 3
        }
      },
      {
        name: 'ad-serving-data_material-statistics',
        path: '/ad-serving-data/material-statistics',
        component: 'view.ad-serving-data_material-statistics',
        meta: {
          title: 'ad-serving-data_material-statistics',
          i18nKey: 'route.ad-serving-data_material-statistics',
          icon: 'carbon:media-library',
          order: 2
        }
      }
    ]
  },
  {
    name: 'apikey',
    path: '/apikey',
    component: 'layout.base$view.apikey',
    meta: {
      title: 'apikey',
      i18nKey: 'route.apikey',
      hideInMenu: true
    }
  },
  {
    name: 'app-manage',
    path: '/app-manage',
    component: 'layout.base',
    meta: {
      title: 'app-manage',
      i18nKey: 'route.app-manage',
      icon: 'carbon:mobile',
      order: 4
    },
    children: [
      {
        name: 'app-manage_app-list',
        path: '/app-manage/app-list',
        component: 'view.app-manage_app-list',
        meta: {
          title: 'app-manage_app-list',
          i18nKey: 'route.app-manage_app-list',
          icon: 'carbon:list'
        }
      },
      {
        name: 'app-manage_app-store-detail',
        path: '/app-manage/app-store-detail/:packageName',
        component: 'view.app-manage_app-store-detail',
        meta: {
          title: 'app-manage_app-store-detail',
          i18nKey: 'route.app-manage_app-store-detail',
          hideInMenu: true,
          activeMenu: 'app-manage_app-list'
        }
      },
      {
        name: 'app-manage_app-user',
        path: '/app-manage/app-user',
        component: 'view.app-manage_app-user',
        meta: {
          title: 'app-manage_app-user',
          i18nKey: 'route.app-manage_app-user',
          icon: 'carbon:user-data'
        }
      },
      {
        name: 'app-manage_monitor',
        path: '/app-manage/monitor',
        component: 'view.app-manage_monitor',
        meta: {
          title: 'app-manage_monitor',
          i18nKey: 'route.app-manage_monitor',
          icon: 'carbon:analytics'
        }
      },
      {
        name: 'app-manage_store-review',
        path: '/app-manage/store-review',
        component: 'view.app-manage_store-review',
        meta: {
          title: 'app-manage_store-review',
          i18nKey: 'route.app-manage_store-review',
          icon: 'carbon:star-review'
        }
      }
    ]
  },
  {
    name: 'function',
    path: '/function',
    component: 'layout.base',
    meta: {
      title: 'function',
      i18nKey: 'route.function',
      icon: 'icon-park-outline:all-application',
      hideInMenu: true,
      order: 5
    },
    children: [
      {
        name: 'function_hide-child',
        path: '/function/hide-child',
        meta: {
          title: 'function_hide-child',
          i18nKey: 'route.function_hide-child',
          icon: 'material-symbols:filter-list-off',
          order: 2
        },
        redirect: '/function/hide-child/one',
        children: [
          {
            name: 'function_hide-child_one',
            path: '/function/hide-child/one',
            component: 'view.function_hide-child_one',
            meta: {
              title: 'function_hide-child_one',
              i18nKey: 'route.function_hide-child_one',
              icon: 'material-symbols:filter-list-off',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          },
          {
            name: 'function_hide-child_three',
            path: '/function/hide-child/three',
            component: 'view.function_hide-child_three',
            meta: {
              title: 'function_hide-child_three',
              i18nKey: 'route.function_hide-child_three',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          },
          {
            name: 'function_hide-child_two',
            path: '/function/hide-child/two',
            component: 'view.function_hide-child_two',
            meta: {
              title: 'function_hide-child_two',
              i18nKey: 'route.function_hide-child_two',
              hideInMenu: true,
              activeMenu: 'function_hide-child'
            }
          }
        ]
      },
      {
        name: 'function_multi-tab',
        path: '/function/multi-tab',
        component: 'view.function_multi-tab',
        meta: {
          title: 'function_multi-tab',
          i18nKey: 'route.function_multi-tab',
          icon: 'ic:round-tab',
          multiTab: true,
          hideInMenu: true,
          activeMenu: 'function_tab'
        }
      },
      {
        name: 'function_request',
        path: '/function/request',
        component: 'view.function_request',
        meta: {
          title: 'function_request',
          i18nKey: 'route.function_request',
          icon: 'carbon:network-overlay',
          order: 3
        }
      },
      {
        name: 'function_super-page',
        path: '/function/super-page',
        component: 'view.function_super-page',
        meta: {
          title: 'function_super-page',
          i18nKey: 'route.function_super-page',
          icon: 'ic:round-supervisor-account',
          order: 5,
          roles: ['R_SUPER']
        }
      },
      {
        name: 'function_tab',
        path: '/function/tab',
        component: 'view.function_tab',
        meta: {
          title: 'function_tab',
          i18nKey: 'route.function_tab',
          icon: 'ic:round-tab',
          order: 1
        }
      },
      {
        name: 'function_toggle-auth',
        path: '/function/toggle-auth',
        component: 'view.function_toggle-auth',
        meta: {
          title: 'function_toggle-auth',
          i18nKey: 'route.function_toggle-auth',
          icon: 'ic:round-construction',
          order: 4
        }
      }
    ]
  },
  {
    name: 'home',
    path: '/home',
    component: 'layout.base$view.home',
    meta: {
      title: 'home',
      i18nKey: 'route.home',
      icon: 'carbon:dashboard',
      order: 1,
      keepAlive: true
    }
  },
  {
    name: 'iframe-page',
    path: '/iframe-page/:url',
    component: 'layout.base$view.iframe-page',
    props: true,
    meta: {
      title: 'iframe-page',
      i18nKey: 'route.iframe-page',
      constant: true,
      hideInMenu: true,
      keepAlive: true
    }
  },
  {
    name: 'login',
    path: '/login/:module(pwd-login|code-login|register|reset-pwd|bind-wechat)?',
    component: 'layout.blank$view.login',
    props: true,
    meta: {
      title: 'login',
      i18nKey: 'route.login',
      constant: true,
      hideInMenu: true
    }
  },
  {
    name: 'manage',
    path: '/manage',
    component: 'layout.base',
    meta: {
      title: 'manage',
      i18nKey: 'route.manage',
      icon: 'carbon:settings',
      order: 9,
      roles: ['admin', 'sub_admin', 'subAdmin']
    },
    children: [
      {
        name: 'manage_logprocessmgr',
        path: '/manage/logprocessmgr',
        component: 'view.manage_logprocessmgr',
        meta: {
          title: 'manage_logprocessmgr',
          i18nKey: 'route.manage_logprocessmgr',
          icon: 'carbon:batch-job',
          order: 4,
          roles: ['admin']
        }
      },
      {
        name: 'manage_menu',
        path: '/manage/menu',
        component: 'view.manage_menu',
        meta: {
          title: 'manage_menu',
          i18nKey: 'route.manage_menu',
          icon: 'carbon:tree-view',
          order: 3,
          roles: ['admin']
        }
      },
      {
        name: 'manage_role',
        path: '/manage/role',
        component: 'view.manage_role',
        meta: {
          title: 'manage_role',
          i18nKey: 'route.manage_role',
          icon: 'carbon:user-role',
          order: 2,
          roles: ['admin']
        }
      },
      {
        name: 'manage_user',
        path: '/manage/user',
        component: 'view.manage_user',
        meta: {
          title: 'manage_user',
          i18nKey: 'route.manage_user',
          icon: 'carbon:user-multiple',
          order: 1,
          roles: ['admin', 'sub_admin', 'subAdmin']
        }
      },
      {
        name: 'manage_user-detail',
        path: '/manage/user-detail/:id',
        component: 'view.manage_user-detail',
        props: true,
        meta: {
          title: 'manage_user-detail',
          i18nKey: 'route.manage_user-detail',
          hideInMenu: true,
          activeMenu: 'manage_user',
          roles: ['admin', 'sub_admin', 'subAdmin']
        }
      }
    ]
  },
  {
    name: 'report-monitor',
    path: '/report-monitor',
    component: 'layout.base$view.report-monitor',
    meta: {
      title: 'report-monitor',
      i18nKey: 'route.report-monitor',
      icon: 'carbon:activity',
      order: 6
    }
  },
  {
    name: 'statistics',
    path: '/statistics',
    component: 'layout.base',
    meta: {
      title: 'statistics',
      i18nKey: 'route.statistics',
      icon: 'carbon:analytics',
      order: 2
    },
    children: [
      {
        name: 'statistics_ab-test',
        path: '/statistics/ab-test',
        component: 'view.statistics_ab-test',
        meta: {
          title: 'statistics_ab-test',
          i18nKey: 'route.statistics_ab-test',
          icon: 'carbon:chemistry',
          order: 1
        }
      },
      {
        name: 'statistics_ad-detail',
        path: '/statistics/ad-detail',
        component: 'view.statistics_ad-detail',
        meta: {
          title: 'statistics_ad-detail',
          i18nKey: 'route.statistics_ad-detail',
          icon: 'carbon:money',
          order: 6
        }
      },
      {
        name: 'statistics_ad-event',
        path: '/statistics/ad-event',
        component: 'view.statistics_ad-event',
        meta: {
          title: 'statistics_ad-event',
          i18nKey: 'route.statistics_ad-event',
          icon: 'carbon:touch-interaction',
          order: 2
        }
      },
      {
        name: 'statistics_app-event-mnage',
        path: '/statistics/app-event-mnage',
        component: 'view.statistics_app-event-mnage',
        meta: {
          title: 'statistics_app-event-mnage',
          i18nKey: 'route.statistics_app-event-mnage',
          icon: 'carbon:event',
          order: 3
        }
      },
      {
        name: 'statistics_churn-statistics',
        path: '/statistics/churn-statistics',
        component: 'view.statistics_churn-statistics',
        meta: {
          title: 'statistics_churn-statistics',
          i18nKey: 'route.statistics_churn-statistics',
          icon: 'carbon:exit',
          order: 6.5
        }
      },
      {
        name: 'statistics_cohort-analysis',
        path: '/statistics/cohort-analysis',
        component: 'view.statistics_cohort-analysis',
        meta: {
          title: 'statistics_cohort-analysis',
          i18nKey: 'route.statistics_cohort-analysis',
          icon: 'carbon:heat-map',
          order: 4
        }
      },
      {
        name: 'statistics_game-level',
        path: '/statistics/game-level',
        component: 'view.statistics_game-level',
        meta: {
          title: 'statistics_game-level',
          i18nKey: 'route.statistics_game-level',
          icon: 'carbon:game-console',
          order: 5
        }
      },
      {
        name: 'statistics_network-status-distribution',
        path: '/statistics/network-status-distribution',
        component: 'view.statistics_network-status-distribution',
        meta: {
          title: 'statistics_network-status-distribution',
          i18nKey: 'route.statistics_network-status-distribution',
          icon: 'carbon:connection-signal'
        }
      },
      {
        name: 'statistics_report-download',
        path: '/statistics/report-download',
        component: 'view.statistics_report-download',
        meta: {
          title: 'statistics_report-download',
          i18nKey: 'route.statistics_report-download',
          icon: 'carbon:report',
          order: 7
        }
      },
      {
        name: 'statistics_roas-adgroup-detail',
        path: '/statistics/roas-adgroup-detail',
        component: 'view.statistics_roas-adgroup-detail',
        meta: {
          title: 'statistics_roas-adgroup-detail',
          i18nKey: 'route.statistics_roas-adgroup-detail',
          hideInMenu: true,
          activeMenu: 'statistics_roas-analysis',
          reuseActiveMenuTab: true
        }
      },
      {
        name: 'statistics_roas-adgroups',
        path: '/statistics/roas-adgroups',
        component: 'view.statistics_roas-adgroups',
        meta: {
          title: 'statistics_roas-adgroups',
          i18nKey: 'route.statistics_roas-adgroups',
          hideInMenu: true,
          activeMenu: 'statistics_roas-analysis',
          reuseActiveMenuTab: true
        }
      },
      {
        name: 'statistics_roas-analysis',
        path: '/statistics/roas-analysis',
        component: 'view.statistics_roas-analysis',
        meta: {
          title: 'statistics_roas-analysis',
          i18nKey: 'route.statistics_roas-analysis'
        }
      },
      {
        name: 'statistics_roas-app-config',
        path: '/statistics/roas-app-config',
        component: 'view.statistics_roas-app-config',
        meta: {
          title: 'statistics_roas-app-config',
          i18nKey: 'route.statistics_roas-app-config',
          hideInMenu: true,
          activeMenu: 'statistics_roas-analysis',
          reuseActiveMenuTab: true
        }
      },
      {
        name: 'statistics_roas-compare',
        path: '/statistics/roas-compare',
        component: 'view.statistics_roas-compare',
        meta: {
          title: 'statistics_roas-compare',
          i18nKey: 'route.statistics_roas-compare',
          hideInMenu: true,
          activeMenu: 'statistics_roas-analysis',
          reuseActiveMenuTab: true
        }
      },
      {
        name: 'statistics_user-activity-query',
        path: '/statistics/user-activity-query',
        component: 'view.statistics_user-activity-query',
        meta: {
          title: 'statistics_user-activity-query',
          i18nKey: 'route.statistics_user-activity-query',
          icon: 'carbon:user-activity',
          order: 8
        }
      }
    ]
  },
  {
    name: 'tools',
    path: '/tools',
    component: 'layout.base$view.tools',
    meta: {
      title: 'tools',
      i18nKey: 'route.tools',
      icon: 'carbon:tools',
      order: 8
    }
  },
  {
    name: 'user-center',
    path: '/user-center',
    component: 'layout.base$view.user-center',
    meta: {
      title: 'user-center',
      i18nKey: 'route.user-center',
      hideInMenu: true
    }
  },
  {
    name: 'user-segment-query',
    path: '/user-segment-query',
    component: 'layout.base',
    meta: {
      title: 'user-segment-query',
      i18nKey: 'route.user-segment-query',
      icon: 'carbon:group',
      order: 3.5
    },
    children: [
      {
        name: 'user-segment-query_user-segment-analysis',
        path: '/user-segment-query/user-segment-analysis',
        component: 'view.user-segment-query_user-segment-analysis',
        meta: {
          title: 'user-segment-query_user-segment-analysis',
          i18nKey: 'route.user-segment-query_user-segment-analysis',
          icon: 'carbon:chart-venn-diagram',
          order: 2
        }
      },
      {
        name: 'user-segment-query_user-segment-label',
        path: '/user-segment-query/user-segment-label',
        component: 'view.user-segment-query_user-segment-label',
        meta: {
          title: 'user-segment-query_user-segment-label',
          i18nKey: 'route.user-segment-query_user-segment-label',
          icon: 'carbon:tag',
          order: 1
        }
      }
    ]
  }
];
